























































































import { Intervention } from "../../models/Intervention";
import Facturation = Intervention.Facturation;
import DateInput from "../../core/Forms/DateInput.vue";
import NumeralInput from "../../core/Forms/NumeraInput.vue";

export default {
    name: "FacturationModalEdit",
    components: { NumeralInput, DateInput },
    props: {
        intervention: Intervention,
    },
    data() {
        return {
            facturation: null,
        };
    },
    created() {
        if (this.intervention.facturation) {
            this.facturation = this.intervention.facturation;
        } else {
            this.facturation = new Facturation({});
            this.facturation.intervention_id = this.intervention.id;
            this.facturation.copropriete_id = this.intervention.client_id;
            this.intervention.facturation = this.facturation;
        }
    },
};
